import React, { Fragment, useContext } from 'react';
import Notify from '../../notification/Notify';
import Axios from 'axios';
import { Box, Grid, Button, TextField, FormHelperText } from '@material-ui/core';
import { Formik } from 'formik';
import * as Yup from 'yup';
import CheckIcon from '@material-ui/icons/CheckCircleOutline'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { PharmacyRoleAndId, UsersData } from '../../ContextAPI';

function AddQtySpecificBatch({ selectedDataArray, fetchInventoryList, getBatchesByProductID, backDefaultView }) {
    const userData = useContext(UsersData);
    const userRAndId = useContext(PharmacyRoleAndId);

    const getFormData = (object) => {
        const formData = new FormData();

        formData.append('product', selectedDataArray.product)
        formData.append('product_id', selectedDataArray.product_id)
        formData.append('description', selectedDataArray.description)
        formData.append('supplier', selectedDataArray.supplier)

        Object.keys(object).forEach(key => formData.append(key, object[key]));
        return formData;
    }

    return (
        <Fragment>
            <Formik
                initialValues={{
                    user_id: userData.users.user_id,
                    username: userData.users.username,
                    management_id: userData.users.management_id,
                    pharmacy_id: userRAndId.userRoleAndId.pharmacy_id,
                    manufacture: selectedDataArray.manufacture_date,
                    batch_no: selectedDataArray.batch_no,
                    expiry: selectedDataArray.expiry_date,
                    invoice: '',
                    qty: '',
                    unit: selectedDataArray.unit,
                    remarks: '',
                    password: '',
                }}
                validationSchema={Yup.object().shape({
                    invoice: Yup.string().required(),
                    qty: Yup.number().required(),
                    remarks: Yup.string().required(),
                    password: Yup.string().required()
                })}
                onSubmit={async (values, {
                    setErrors,
                    setSubmitting,
                    resetForm
                }) => {
                    try {
                        const request = await Axios.post('pharmacy/add-qty-by-specific', getFormData(values))
                        if (request.data === 'pass-invalid') {
                            setErrors({ password: "Password doesn't matched" });
                            Notify.customToast("Invalid Password", "Password doesn't matched")
                        }
                        if (request.data === 'invoice-exist') {
                            setErrors({ invoice: 'Invoice is already recorded' });
                            Notify.customToast('Invoice Exist', 'Invoice is already recorded')
                        }
                        if (request.data === 'success') {
                            Notify.successRequest('new product')
                            fetchInventoryList();
                            getBatchesByProductID();
                            resetForm();
                            setSubmitting(true);
                            backDefaultView();
                        }
                    } catch (error) {
                        const message = error.message || 'Something went wrong';
                        setErrors({ submit: message });
                        setSubmitting(false);
                    }
                }}
            >
                {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    touched,
                    values,
                    resetForm
                }) => (
                    <form
                        noValidate
                        onSubmit={handleSubmit}
                    >
                        <Box flexGrow={1}>
                            <Grid container spacing={2}>
                                <Grid xs={4} item>
                                    <Box mb={1}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            required
                                            fullWidth
                                            label="Manufacture Date"
                                            error={Boolean(touched.manufacture && errors.manufacture)}
                                            helperText={touched.manufacture && errors.manufacture}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.manufacture}
                                            name="manufacture"
                                            variant="outlined"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Box>
                                </Grid>
                                <Grid xs={4} item>
                                    <Box mb={1}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            error={Boolean(touched.batch_no && errors.batch_no)}
                                            helperText={touched.batch_no && errors.batch_no}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            defaultValue={values.batch_no}
                                            fullWidth
                                            required
                                            multiline
                                            name="batch_no"
                                            label="Batch Number"
                                            variant="outlined"
                                        />
                                    </Box>
                                </Grid>
                                <Grid xs={4} item>
                                    <Box mb={1}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            required
                                            fullWidth
                                            label="Expiry Date"
                                            error={Boolean(touched.expiry && errors.expiry)}
                                            helperText={touched.expiry && errors.expiry}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.expiry}
                                            name="expiry"
                                            variant="outlined"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Box>
                                </Grid>
                                <Grid xs={4} item>
                                    <Box mb={1}>
                                        <TextField
                                            error={Boolean(touched.invoice && errors.invoice)}
                                            helperText={touched.invoice && errors.invoice}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            defaultValue={values.invoice}
                                            fullWidth
                                            required
                                            name="invoice"
                                            label="Invoice Number"
                                            variant="outlined"
                                        />
                                    </Box>
                                </Grid>

                                <Grid xs={4} item>
                                    <Box mb={1}>
                                        <TextField
                                            error={Boolean(touched.qty && errors.qty)}
                                            helperText={touched.qty && errors.qty}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            defaultValue={values.qty}
                                            fullWidth
                                            required
                                            name="qty"
                                            label="Quantity"
                                            type="number"
                                            variant="outlined"
                                        />
                                    </Box>
                                </Grid>

                                <Grid xs={4} item>
                                    <Box mb={1}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            error={Boolean(touched.unit && errors.unit)}
                                            helperText={touched.unit && errors.unit}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            defaultValue={values.unit}
                                            fullWidth
                                            required
                                            multiline
                                            name="unit"
                                            label="Unit"
                                            variant="outlined"
                                        />
                                    </Box>
                                </Grid>

                                <Grid xs={12} item>
                                    <Box mb={1}>
                                        <TextField
                                            error={Boolean(touched.remarks && errors.remarks)}
                                            helperText={touched.remarks && errors.remarks}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            defaultValue={values.remarks}
                                            fullWidth
                                            required
                                            multiline
                                            name="remarks"
                                            label="Remarks"
                                            variant="outlined"
                                        />
                                    </Box>
                                </Grid>

                                <Grid xs={12} item>
                                    <Box mb={1}>
                                        <TextField
                                            fullWidth
                                            required
                                            error={Boolean(touched.password && errors.password)}
                                            helperText={touched.password && errors.password}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.password}
                                            name="password"
                                            label="Enter your password"
                                            variant="outlined"
                                            type="password"
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>

                        {errors.submit && (
                            <Box mt={2} >
                                <FormHelperText error>
                                    {errors.submit}
                                </FormHelperText>
                            </Box>
                        )}

                        <Box mt={2} mb={2} display="flex">
                            <Box flexGrow={1} />

                            <Button
                                variant="contained"
                                color="default"
                                onClick={() => backDefaultView()}
                                startIcon={<ArrowBackIcon />}
                            >
                                Back
                            </Button>

                            <Box ml={2}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    startIcon={<CheckIcon />}
                                    disabled={isSubmitting}
                                >
                                    Save
                                </Button>
                            </Box>
                        </Box>
                    </form>
                )}
            </Formik>
        </Fragment>
    )

}

export default AddQtySpecificBatch;